import React from 'react';
import classNames from 'classnames/bind';
import styles from './testGuideTooltip.module.scss';

const cx = classNames.bind(styles);

const TestGuideTooltip = () => {
  return (
    <a className={cx('testGuideTooltipArea')} role="button">
      <div className={cx('tooltip')}>
        <div className={cx('infoArea')}>
          <em className={cx('infoTitle')}>이상이 없는 경우</em>
          <div className={cx('infoImgWrap', 'noProblem')}>
            <span className={cx('hidden')}>
              안정적으로
              <br />
              응시했어요!
              <br />
              아래의 개별 피드백도 꼭 확인해 보세요.
            </span>
          </div>
          <p className={cx('desc')}>큰 문제 없이 응시를 완료한 것을 의미합니다.</p>
        </div>

        <div className={cx('infoArea')}>
          <em className={cx('infoTitle')}>이상이 있는 경우</em>
          <div className={cx('infoImgWrap', 'problem')}>
            <span className={cx('hidden')}>
              보완점을
              <br />
              확인해 보세요!
              <br />
              응시 가이드와 안내 표시를 확인해 주세요.
            </span>
          </div>
          <p className={cx('desc')}>응시 중 이상이 감지된 것을 의미합니다.</p>
        </div>
      </div>
    </a>
  );
};

export default TestGuideTooltip;
